export const LAST_ORDER_KEY = 'raheasy_last_order';
export const LAST_INQUIRY_KEY = 'raheasy_last_inquiry';

export function generateOrderId() {
  return `RH-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}

export function generateInquiryId() {
  return `RH-INQ-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}

/** YYYY-MM-DD for Google Customer Reviews estimated_delivery_date. */
export function getEstimatedDeliveryDate(deliveryOptionId) {
  const date = new Date();
  const hour = date.getHours();

  if (deliveryOptionId === 'same-day') {
    if (hour >= 12) {
      date.setDate(date.getDate() + 1);
    }
  } else if (deliveryOptionId === 'next-day') {
    date.setDate(date.getDate() + 1);
  } else {
    date.setDate(date.getDate() + 2);
  }

  return date.toISOString().slice(0, 10);
}

export function persistLastOrder(order) {
  try {
    sessionStorage.setItem(LAST_ORDER_KEY, JSON.stringify(order));
  } catch {
    /* ignore quota errors */
  }
}

export function readLastOrder() {
  try {
    const raw = sessionStorage.getItem(LAST_ORDER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function persistLastInquiry(inquiry) {
  try {
    sessionStorage.setItem(LAST_INQUIRY_KEY, JSON.stringify(inquiry));
  } catch {
    /* ignore quota errors */
  }
}

export function readLastInquiry() {
  try {
    const raw = sessionStorage.getItem(LAST_INQUIRY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function buildWhatsAppOrderMessage(order) {
  const lines = (order.items || []).map(
    (item) =>
      `${item.name} x${item.quantity} - Ksh ${(item.price * item.quantity).toLocaleString('en-KE')}`
  );

  const emailLine = order.deliveryInfo?.email ? `Email: ${order.deliveryInfo.email}\n` : '';

  return [
    'Hello! I would like to place an order:',
    '',
    lines.join('\n'),
    '',
    `Subtotal: Ksh ${Number(order.subtotal || 0).toLocaleString('en-KE')}`,
    `Delivery: Ksh ${Number(order.deliveryCost || 0).toLocaleString('en-KE')}`,
    `Total: Ksh ${Number(order.total || 0).toLocaleString('en-KE')}`,
    '',
    `Order ref: ${order.orderId}`,
    `Delivery: ${order.deliveryOption || 'Standard'}`,
    '',
    `Name: ${order.deliveryInfo?.name || 'Not provided'}`,
    emailLine.trim(),
    `Phone: ${order.deliveryInfo?.phone || 'Not provided'}`,
    `Address: ${order.deliveryInfo?.address || 'Not provided'}`,
    `City: ${order.deliveryInfo?.city || 'Not provided'}`,
  ]
    .filter(Boolean)
    .join('\n');
}
